import React from "react";

const About = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold">About Page</h1>
    </div>
  );
};

export default About;
